//スムーススクロール
$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});

//matchHeight
$(function() {
	$('.u-menu-name').matchHeight();
});

//ナビゲーション用
$(function(){
	$('#gnav_btn').on('click', function(){
		if($(this).hasClass('open')){
			$(this).removeClass('open');
			$('header nav').removeClass('open').stop().slideUp(200);
			$('body').removeClass('add_overray');
			$('.u-menu-name').matchHeight();
		}else{
			$(this).addClass('open');
			$('header nav').addClass('open').stop().slideDown(600);
			$('body').addClass('add_overray');
			$('.u-menu-name').matchHeight();
		}
	});
	$('.outside').on('click', function(){
		$('#gnav_btn').removeClass('open');
		$('header nav').removeClass('open').stop().slideUp(200);
		$('body').removeClass('add_overray');
	});
	$('header nav a').on('click', function(){
		$('#gnav_btn').removeClass('open');
		$('header nav').removeClass('open').stop().slideUp(200);
		$('body').removeClass('add_overray');
	});
});


//スクロールフェードイン
/* 到達したら要素を表示させる */
function showElementAnimation() {
                    
	var element = document.getElementsByClassName('fadeIn');
	if(!element) return; // 要素がなかったら処理をキャンセル
						
	var showTiming = window.innerHeight > 768 ? 200 : 80; // 要素が出てくるタイミングはここで調整
	var scrollY = window.pageYOffset; //スクロール量を取得
	var windowH = window.innerHeight; //ブラウザウィンドウのビューポート(viewport)の高さを取得
					  
	for(var i=0;i<element.length;i++) { 
	  var elemClientRect = element[i].getBoundingClientRect(); 
	  var elemY = scrollY + elemClientRect.top; 
	  if(scrollY + windowH - showTiming > elemY) {
		element[i].classList.add('scrollin');
	  } else if(scrollY + windowH < elemY) {
	  // 上にスクロールして再度非表示にする場合はこちらを記述
		element[i].classList.remove('scrollin');
	  }
	}
}
showElementAnimation();
window.addEventListener('scroll', showElementAnimation);


//SVG
window.addEventListener('load', function(){
  deSVG('.desvg', true);
});


//ローディングアニメーション
window.onload = function() {
	const spinner = document.getElementById('loading-wrapper');
	// Add .loaded to .loading
	spinner.classList.add('loaded');
}


// 動きのきっかけとなるアニメーションの名前を定義
function fadeAnime(){
	// ふわっ
	$('.fadeUpTrigger').each(function(){ //fadeUpTriggerというクラス名が
	  var elemPos = $(this).offset().top-50;//要素より、50px上の
	  var scroll = $(window).scrollTop();
	  var windowHeight = $(window).height();
	  if (scroll >= elemPos - windowHeight){
	  $(this).addClass('fadeUp');// 画面内に入ったらfadeUpというクラス名を追記
	  }else{
	  $(this).removeClass('fadeUp');// 画面外に出たらfadeUpというクラス名を外す
	  }
	});
}

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function (){
	fadeAnime();/* アニメーション用の関数を呼ぶ*/
});// ここまで画面をスクロールをしたら動かしたい場合の記述

// 画面が読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function(){
	fadeAnime();/* アニメーション用の関数を呼ぶ*/
});// ここまで画面が読み込まれたらすぐに動かしたい場合の記述

$('.slide').slick({
		autoplay: true, //自動再生
		infinite: true, //スライドのループ有効化
		draggable: true,
		arrows: true,
		slidesToShow: 4, //表示するスライドの数
		slidesToScroll: 4, //スクロールで切り替わるスライドの数
		responsive: [{
			breakpoint: 768, //ブレークポイントが768px
			settings: {
			slidesToShow: 3, //表示するスライドの数
			slidesToScroll: 3, //スクロールで切り替わるスライドの数
			}
		}]
	});

